import { useEffect } from 'react';
import ReactGA from 'react-ga4';

import { useHelpScoutBeacon } from '@/hooks/useHelpScoutBeacon';

import { AppProvider } from './provider';
import { AppRouter } from './router';

export const App = () => {
  useEffect(() => {
    ReactGA.initialize('AW-11002420700');
  }, []);
  useHelpScoutBeacon();

  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
